function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { TimePicker } from 'antd';
import moment from 'moment';
export var BetterTimePicker = function BetterTimePicker(props) {
  var onTimeChange = props.onTimeChange;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TimePicker, _extends({
    onKeyDown: function onKeyDown(e, preventDefault) {
      if (!(e.target instanceof HTMLInputElement)) {
        return;
      }
      if (/^[ap]$/i.test(e.key) && !e.metaKey) {
        e.target.value += e.key;
        // prevent default antd behavior adding `m` suffix
        e.nativeEvent.preventDefault();
      }
      if (e.key === 'Enter' || e.keyCode === 13) {
        var currValue = e.target.value;
        var time = moment(currValue, 'HH:mm a');

        // require the user to enter a value with a colon
        if (/:/i.test(currValue) && time.isValid()) {
          onTimeChange(time);
        } else {
          // prevents the panel from closing if not a valid time
          preventDefault();
        }
      }
    },
    onChange: onTimeChange,
    onSelect: onTimeChange
  }, props)));
};